
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";
import SweetAlert from "app/pages/components/mui/Alerts/SweetAlert";
import {
  Grid,
} from "@mui/material";
import { createCoursesAPI, deleteCoursesAPI, getCoursesAPI, updateCoursesAPI } from 'backendServices/ApiCalls';
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button} from "@mui/material";
import Div from "@jumbo/shared/Div/Div";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";





const CourseListing = () => {
const [list,setList]=useState([])
const [value,setValues]=useState({title:"",description:""})

const [isLoading,setIsLoading]=useState(false)
const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);

  
  const [alertData, setalertData] = useState({
    show: false,
    message: "",
    variant: "",
  });




  const getCourses = () => {
    setIsLoading(true);
    getCoursesAPI(
      (response) => {
        const processedData = response?.data?.data?.map((row, index) => ({
          ...row,
          index: index + 1,
        }));
        setList(processedData);
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        console.log(error);
      }
    );
      setIsLoading(false);
  };

  

  useEffect(() => {
    getCourses();
  }, []);

  const handleSubmit = ()=>{
    if (!value?.description || !value?.title) {
      setalertData({ show: true,
                    message: "Description and title are required",
                    variant: "error"});
      return
    }

     createCoursesAPI(value,
      (response) => {
        setalertData({ show: true,
                    message: "Course created Successfully",
                    variant: "success"});
         setOpen(false)
         getCourses();
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
         setalertData({ show: true,
                    message: "Something Went Wrong",
                    variant: "error"});
        console.log(error);
      }
    );

  }
  
   const handleUpdateSubmit = ()=>{
    if (!value?.description || !value?.title) {
      setalertData({ show: true,
                    message: "Description and title are required",
                    variant: "error"});
      return
    }

    const payload = {
        ...value,
        courseId:value?.id
    }
     updateCoursesAPI(payload,
      (response) => {
        setalertData({ show: true,
                    message: "Course updated Successfully",
                    variant: "success"});
         setOpenUpdate(false)
         getCourses();
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
         setalertData({ show: true,
                    message: "Something Went Wrong",
                    variant: "error"});
        console.log(error);
      }
    );

  }

  const handleUpdateOpen = (values)=>{
   setValues({...values})
   setOpenUpdate(true)
  }

  const deleteCourse = (courseId) =>{

    deleteCoursesAPI({courseId},
      (response) => {
        setalertData({ show: true,
                    message: "Course Deleted Successfully",
                    variant: "success"});
         
         getCourses();
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
         setalertData({ show: true,
                    message: "Something Went Wrong",
                    variant: "error"});
        console.log(error);
      }
    );
  }





   var columns = [
      {
        field: "index",
        headerName: "#",
        width: 80,
      },
      {
        field: "title",
        headerName: "Title",
        width: 300,
        groupable: false,
         renderCell: (params) => (
          <span style={{ cursor: "pointer"}}
           onClick={() =>navigate(`/courses-users?cid=${params.row.id}`)} >
           {params.value}
         </span>
  ),
      },
       {
        field: "description",
        headerName: "Description",
        width: 300,
        groupable: false,
      },
       {
            field: "update",
            headerName: "Update",
            width: 100,
            editable: true,
            groupable: false,
            aggregable: false,
            renderCell: (params) => (
              <>
                <EditIcon
                  color="warning"
                  style={{ cursor: "pointer" }}
                  onClick={()=>handleUpdateOpen(params.row)}
                 
                />
              </>
            ),
          },
          {
            field: "delete",
            headerName: "Delete",
            width: 120,
            editable: true,
            groupable: false,
            aggregable: false,
            renderCell: (params) => (
              <DeleteIcon
                style={{ cursor: "pointer", color: "red" }}
                onClick={()=>deleteCourse(params.row.id)}
              />
            ),
          },
    ];
 
  // }
  const gridDesign = {
    "& .MuiDataGrid-toolbarContainer": {
      "& .MuiButton-text": {
        fontSize: "13px !important",
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
        // color: '#074682',
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
      },
      "& .MuiInput-root": {
        borderRadius: 2,
        paddingLeft: 2,
        overflow: "hidden",
      },
    },
  };
  //



  
  



  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
      
    >

      <Div sx={{ display: "flex", justifyContent: "flex-end" ,width:"100%" }}>
          <Button variant="contained" onClick={() => {
            setOpen(true)
            setValues({})
          }}>
            Create
          </Button>

          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{  display: "flex", justifyContent: "center" , fontWeight:600,fontSize:"20px"}}
            >
            {"Create Course"}
            </DialogTitle>
            <DialogContent style={{paddingTop:"20px"}}>
             <Grid item width={500}>
                      <TextField
                        fullWidth
                        name="Title"
                        label="Title"
                        type="text"
                        value={value?.title || ''}
                        onChange={(e)=>setValues({...value,title:e.target.value})}
                      />
                    </Grid>

                    <Grid item xs={12} style={{paddingTop:"20px"}}>
                      <TextField
                        fullWidth
                        name="Description"
                        label="Description"
                        type="text"
                        value={value?.description || ''}
                        onChange={(e)=>setValues({...value,description:e.target.value})}
                      />
                    </Grid>
             
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleSubmit}
              >
                Create
              </Button>
              <Button onClick={() => setOpen(false)} autoFocus>
                {t("pages.title.cancel")}{" "}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openUpdate}
            onClose={() => setOpenUpdate(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{  display: "flex", justifyContent: "center" , fontWeight:600,fontSize:"20px"}}
            >
            {"Update Course"}
            </DialogTitle>
            <DialogContent style={{paddingTop:"20px"}}>
             <Grid item width={500}>
                      <TextField
                        fullWidth
                        name="Title"
                        label="Title"
                        type="text"
                        value={value?.title || ''}
                        onChange={(e)=>setValues({...value,title:e.target.value})}
                      />
                    </Grid>

                    <Grid item xs={12} style={{paddingTop:"20px"}}>
                      <TextField
                        fullWidth
                        name="Description"
                        label="Description"
                        type="text"
                        value={value?.description || ''}
                        onChange={(e)=>setValues({...value,description:e.target.value})}
                      />
                    </Grid>
             
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleUpdateSubmit}
              >
                Update
              </Button>
              <Button onClick={() => setOpenUpdate(false)} autoFocus>
                {t("pages.title.cancel")}{" "}
              </Button>
            </DialogActions>
          </Dialog>

        </Div>
      <Grid item sm={12} xs={12}>
        <JumboDemoCard
          title={""}
          wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
        >
          {alertData.show && (
            <SweetAlert alertData={alertData} setalertData={setalertData} />
          )}


          <Box sx={{ height: 500, width: 1 }}>
            <DataGrid
              initialState={{
                pagination: { paginationModel: { pageSize: 6 } },
              }}
              rows={list}
              getRowId={(row) => row.id}
              columns={columns}
              slots={{ toolbar: GridToolbar }}
              sx={gridDesign}
              pageSizeOptions={[6, 12, 18, 24, 30]}
              loading={isLoading}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
   
          {/* )} */}

         
        </JumboDemoCard>
      </Grid>


    </Grid>
  );
};

export default CourseListing;




